module.exports = __webpack_public_path__ + "img/dpa.ef2cb03f.png";